export default __webpack_public_path__ + "static/media/home.bfd55238.svg";